// eslint-disable-next-line import/no-extraneous-dependencies
import { map, prop } from 'ramda';
import { IAddressDetailMobSiteSchema } from '../../types/recommendation';

export const addressToString = (data: IAddressDetailMobSiteSchema[]): string => {
  return map(prop('value'), data).join(', ');
};
